import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSocialStore } from '../../social/socialStore.ts';
import { Button } from '../../ui/index.ts';
import styles from './Social.module.css';

/** The newest invitation to a private table, wherever the player is in the app but at a table already. */
export function InviteBanner() {
  const { t } = useTranslation('social');
  const navigate = useNavigate();
  const location = useLocation();
  const invite = useSocialStore((s) => s.invites[s.invites.length - 1]);
  const dismiss = useSocialStore((s) => s.dismissInvite);
  if (!invite) return null;
  // At a table, or in the middle of a heist, an invitation would only be in the way.
  if (location.pathname === '/game' || location.pathname === '/training') return null;
  if (location.pathname === '/online/room') return null;
  return (
    <div className={styles['invite']} role="alert" data-testid="invite">
      <span className={styles['inviteText']}>{t('invite.banner', { name: invite.from })}</span>
      <Button
        onClick={() => {
          dismiss(invite.id);
          void navigate(`/online/join/${invite.code}`);
        }}
      >
        {t('invite.join')}
      </Button>
      <Button
        variant="ghost"
        onClick={() => {
          dismiss(invite.id);
        }}
      >
        {t('invite.dismiss')}
      </Button>
    </div>
  );
}
